import { render, staticRenderFns } from "./MenuRecommendationsView.vue?vue&type=template&id=793fc466&scoped=true"
import script from "./MenuRecommendationsView.vue?vue&type=script&lang=js"
export * from "./MenuRecommendationsView.vue?vue&type=script&lang=js"
import style0 from "./MenuRecommendationsView.vue?vue&type=style&index=0&id=793fc466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793fc466",
  null
  
)

export default component.exports